import { type HeroType, type HeroVariations } from '@Types/Blocks/Hero';
import type { ContainerTypeEnums } from '@Types/Shared/Common';
import type { FrontWPImage } from '@Types/Shared/Image';

import { useContext, useEffect, useState, type ComponentProps } from 'react';

import defu from 'defu';
import _ from 'lodash';

import { getImage } from '@Blocks/_lib/getImageUrl';

import type { Options } from '@/_types/Shared/Options';
import { MinosContext } from '@/views/Shared/Context';
import { HeroStyle } from '@/views/Shared/GlobalStyles/GlobalStyles';

import Block from './Block';

declare const minosOptions: any;

type Heroregister = {
	block: HeroType;
	variant: HeroVariations;
	containerType: ContainerTypeEnums;
	context?: string;
};

export default function Register(props: Heroregister) {
	const { block, variant = 'classic', containerType = 'wide', context = 'front' } = props;

	const { composition } = block;

	const MinosOptions: Options =
		context === 'front' ? useContext(MinosContext) : JSON.parse(minosOptions);

	const [image, setImage] = useState<FrontWPImage>();

	useEffect(() => {
		if (block.image) {
			getImage(setImage, block.image, 'large');
		}
	}, [block.image]);

	let propsHero: ComponentProps<typeof Block> = {
		id: block.id ? block.id : '',
		title: block.title,
		description: block.description,
		image: image,
		img_position: block.img_position || 'left',
		ctas: block.ctas,
		titleFormat: block.titleFormat || 'h1',
		variant: variant,
		containerType: containerType,
		contentFontFormats: block.contentFontFormats,
		ctasStyle: MinosOptions.blocks.hero.default.ctasStyle,
		sectionDecoration: MinosOptions.layout.sectionDecoration,
		placement: block.placement,
	};

	if (composition && composition != 'none') {
		const compoOptions = _.find(MinosOptions.blocks.hero.compositions, { id: composition });
		if (compoOptions) {
			propsHero = defu(compoOptions as ComponentProps<typeof Block>, propsHero);
			propsHero.style = HeroStyle(compoOptions);
		}
	}

	return <Block {...propsHero} />;
}
